/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: branding-container-properties-component.ts
 *
 * Created by kyang on 10/16/2020.
 */

function BrandingContainerPropertiesController (
    this: JS5Object,
    $location: JS5Object,
    $q: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    BrandingAssetService: JS5Object,
    BrandingContainerEditService: JS5Object,
    BreadcrumbService: JS5Object,
    BrandingViewService: JS5Object,
    NotificationService: JS5Object,
    SidebarService: JS5Object,
) {
    enum ContainerType {
        PRE_ROLL = 'preRolls',
        POST_ROLL = 'postRolls',
        BREAK_PRE_POST_ROLL = 'breakPrePostRolls',
        ARTWORK = 'artwork',
        WATERMARK = 'watermarks',
    }

    this.editingNewBrandingAssetContainer = () => {
        return $routeParams.containerId === '-1';
    };

    this.editingPreRolls = () => {
        return this.brandingConfig.type === ContainerType.PRE_ROLL;
    };

    this.toggleHidden = () => {
        this.hideEmpty = !this.hideEmpty;
    };

    this.onAcceptProfileClicked = () => {
        if (!this.editorForm.$pristine) {
            NotificationService.createWarningNotification(
                'You have unsaved changes. Please save or revert.', '');
        }
    };


    //=========//
    // Toolbar //
    //=========//

    const saveEditData = () => {
        let networkOrContent = ($location.path().indexOf('networks') !== -1) ? 'networks' : 'content';
        let savePromise: JS5Promise;
        this.loadingIndicator.show = true;

        if ($routeParams.type === ContainerType.BREAK_PRE_POST_ROLL) {
            this.brandingAssetContainer.breakPrePostRolls = [];
        }
        if (this.editingNewBrandingAssetContainer()) {
            savePromise = BrandingAssetService.createBrandingAssetContainer(
                this.brandingConfig,
                $routeParams.id,
                this.brandingAssetContainer
            );
        } else {
            savePromise = BrandingAssetService.updateBrandingAssetContainer(
                this.brandingConfig,
                this.brandingAssetContainer
            );
        }
        savePromise.then((brandingAssetContainer: JS5Object) => {
            brandingAssetContainer.leadBlackDuration = _.toNumber(brandingAssetContainer.leadBlackDuration);
            BrandingContainerEditService.setOriginalEditData(brandingAssetContainer);
            this.brandingAssetContainer = brandingAssetContainer;
            $route.updateParams({containerId: brandingAssetContainer.id});
        })
        .finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const revertEditData = () => {
        this.brandingAssetContainer = _.cloneDeep(BrandingContainerEditService.originalEditData);
        this.editorForm.$setPristine();
        if (this.editingNewBrandingAssetContainer()) {
            exitEdit();
        }
    };

    const exitEdit = () => {
        $location.path(this.brandingConfig.parentLocation);
        $location.search(`view=${this.brandingConfig.type}`);
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => this.canWriteContainer && !this.editorForm.$pristine && this.editorForm.$valid,
            onClick: saveEditData
        }, {
            label: 'Revert',
            enabled: () => !this.editorForm.$pristine || this.editingNewBrandingAssetContainer(),
            onClick: revertEditData
        }, {
            label: 'Close',
            enabled: () => this.editorForm.$pristine && !this.editingNewBrandingAssetContainer(),
            onClick: exitEdit
        }
    ];


    //=================//
    // Lifecycle Hooks //
    //=================//

    const getData = () => {
        this.loadingIndicator.show = true;
        return $q.all({
            container: BrandingAssetService.getBrandingAssetContainer(this.brandingConfig),
            mediaAcceptProfiles: BrandingViewService.getMediaAcceptProfiles(),
        })
            .then((data: JS5Object) => {
                data.container.leadBlackDuration = _.toNumber(data.container.leadBlackDuration);
                BrandingContainerEditService.setOriginalEditData(data.container);
                if (this.canReadContainer) {
                    this.brandingAssetContainer = data.container;
                    this.mediaAcceptProfiles = data.mediaAcceptProfiles;
                }
            })
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    this.$onInit = () => {
        this.hideEmpty = false;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        this.loadingIndicator.show = true;
        BrandingViewService.getReadWritePermissions(this.brandingConfig)
            .then((permissions: JS5Object) => {
                this.canReadContainer = permissions.read;
                this.canWriteContainer = permissions.write;
                return getData();
            });
    };

    this.$postLink = () => {
        BrandingContainerEditService.editorForm = this.editorForm;
        BreadcrumbService.editService = BrandingContainerEditService;
        SidebarService.editService = BrandingContainerEditService;
    };

    this.$onDestroy = () => {
        BrandingContainerEditService.editorForm = null;
    };
}

angular
    .module('prism-ui.components.branding')
    .component('brandingContainerProperties', {
        templateUrl: 'components/branding/editView/components/properties/branding-container-properties-template.html',
        controller: BrandingContainerPropertiesController,
        bindings: {
            brandingConfig: '<',
        }
    });
